import { prepareGoalProgress } from './prepareGoalProgress';
import { AchievementCard, UserAchievement } from './types';

/**
 * Prepares user achievement data for AchievementCard component
 *
 * @method prepareAchievementCard
 * @memberof Gamification
 * @param  {UserAchievement} userAchievement - User achievement data
 * @returns {AchievementCard} - AchievementCard properties
 */

export const prepareAchivementCard = (userAchievement: UserAchievement): AchievementCard => {
  const achievement = userAchievement.achievement;
  const goals = achievement.goals;

  const processedGoals = [];

  for (const goal of goals) {
    const userAchievementGoals = userAchievement.progress.goals;
    const processedGoal = prepareGoalProgress(goal, userAchievementGoals);

    processedGoals.push(processedGoal);
  }

  const achievementName = achievement.name;
  const badgeImage = achievement.badge_image;

  const badge = {
    image: `/content/communications/BADGE/${badgeImage}`,
    title: '',
  };

  const description = '';
  const motivationText = '';

  return {
    name: achievementName,
    description: description,
    motivationText: motivationText,
    progressBar: { percentage: userAchievement.progress.percentage },
    badge: badge,
    progressStatus: processedGoals,
    awards: achievement.awards,
  };
};
